import { supabase } from '../../../shared/lib/supabaseClient';
import { logActivity } from '../../../shared/services/activityLogService';

export async function getAllOfficers() {
  const { data, error } = await supabase
    .from('officers')
    .select('auth_id, email, firstname, lastname, middlename, contact_number, role, status, approved, approved_at, created_at')
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data;
}

export async function getPendingOfficers() {
  const { data, error } = await supabase
    .from('officers')
    .select('auth_id, email, firstname, lastname, role, created_at')
    .eq('approved', false)
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data;
}

export async function approveOfficer(authId, label) {
  const {
    data: { user },
    error: userError,
  } = await supabase.auth.getUser();
  if (userError) throw userError;

  const { error } = await supabase
    .from('officers')
    .update({
      approved: true,
      approved_by: user.id,
      approved_at: new Date().toISOString(),
    })
    .eq('auth_id', authId);

  if (error) throw error;
  await logActivity('approve_officer', `Approved officer ${label || authId}`);
}

export async function rejectOfficer(authId, label) {
  const { error } = await supabase
    .from('officers')
    .delete()
    .eq('auth_id', authId);

  if (error) throw error;
  await logActivity('reject_officer', `Rejected officer signup ${label || authId}`);
}

export async function updateOfficerRole(authId, role) {
  const { error } = await supabase
    .from('officers')
    .update({ role })
    .eq('auth_id', authId);

  if (error) throw error;
}

export async function updateOfficerStatus(authId, status) {
  const { error } = await supabase
    .from('officers')
    .update({ status })
    .eq('auth_id', authId);

  if (error) throw error;
}

export async function deleteOfficer(authId) {
  const { error } = await supabase
    .from('officers')
    .delete()
    .eq('auth_id', authId);

  if (error) throw error;
}
